<div style="width: 50%; margin: auto">
  <img src="assets/images/logo.png" alt="" />
  <h2>Svebar</h2>

  <p>
    Du har behörighet till fler än 1 laboratorium. För att fortsätta måste du välja vilket laboratorium du vill agera
    för. För att byta laboratorium behöver du logga ut och in.
  </p>
  <div>
    <label>Laboratorium <span class="text-danger">*</span></label>
  </div>
  <div *ngIf="anvandareOrganisationer$ | async as orgs ">

    <p-select [options]="orgs" optionLabel="organisation" placeholder="Välj organisation" (onChange)="loginWithSpecifiedOrganisation($event)"></p-select>
  </div>
</div>
